import { FC, ReactNode } from 'react';

import { GolferDetails } from '@/api/golfer/golfer.types.ts';
import CustomGrid from '@/components/controls/CustomGrid.tsx';
import CustomGridLabelValueRow, {
  LabelValueGridRow,
} from '@/components/controls/CustomGridLabelValueRow.tsx';

type GolferDetailsGridProps = {
  golferDetails: GolferDetails;
};

const GolferDetailsGrid: FC<GolferDetailsGridProps> = ({
  golferDetails,
}: GolferDetailsGridProps) => {
  const gridData: LabelValueGridRow[] = [
    {
      id: 'name',
      label: 'Golfer Name:',
      value: golferDetails.name,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/3 mr-12',
      valueStyle: 'w-2/3',
    },
    {
      id: 'mobile',
      label: 'Mobile Number:',
      value: golferDetails.mobileNumber,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/3 mr-12',
      valueStyle: 'w-2/3',
    },
    {
      id: 'email',
      label: 'Email:',
      value: golferDetails.email,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/3 mr-12',
      valueStyle: 'w-2/3 break-all',
    },
    {
      id: 'accountType',
      label: 'Account Type:',
      value: golferDetails.accountType,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/3 mr-12',
      valueStyle: 'w-2/3 capitalize',
    },
    {
      id: 'registrationNo',
      label: 'Registration No:',
      value: golferDetails.registrationNo,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/3 mr-12',
      valueStyle: 'w-2/3',
    },
    {
      id: 'country',
      label: 'Country:',
      value: golferDetails.country,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/3 mr-12',
      valueStyle: 'w-2/3',
    },
    {
      id: 'holeInOnes',
      label: 'Hole-in-ones:',
      value: golferDetails.holeInOnes?.toString() ?? '0',
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/3 mr-12',
      valueStyle: 'w-2/3',
    },
  ];

  const golferDetailsGridItem: ReactNode[] = gridData.map((item) => (
    <CustomGridLabelValueRow
      key={item.id}
      id={item.id}
      rowStyle={item.rowStyle}
      label={item.label}
      labelStyle={item.labelStyle}
      value={item.value}
      noValueText="N/A"
      valueStyle={item.valueStyle}
    />
  ));

  return (
    <CustomGrid
      items={golferDetailsGridItem}
      cols={1}
      gap={6}
      className="mt-4 mb-4"
    />
  );
};

export default GolferDetailsGrid;
